module.exports = __webpack_public_path__ + "static/media/University-Of-Calgary-Logo.ce61287b.png";